import BadgeAssigneeEdit from '@/screens/BadgeAssigneeEdit';

export default function PrivateBadgeAssigneeCreateRoute() {
  return <BadgeAssigneeEdit />;
}
